<template>
  <div
    v-if="showWidget"
    :data-gyg-partner-id="gygPartnerId"
    :data-gyg-number-of-items="data.numberOfItems"
    :data-gyg-currency="data.currency"
    :data-gyg-locale-code="data.localeCode"
    :data-gyg-cmp="data.cmp"
    :data-gyg-placement="data.placement"
    :data-gyg-iata="data.iata"
    data-gyg-widget="activites"
    :data-gyg-href="getHref"
  />
</template>

<script>
  import conf from 'conf'

  export default {
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    computed: {
      gygPartnerId () {
        return conf.gygPartnerId
      },
      showWidget () {
        return conf.gygPartnerId && this.data.iata
      },
      getHref () {
        return `${conf.gygWidgetUrl}/${conf.gygPartnerId}/activities.frame`
      }
    },
    mounted () {
      const script = document.querySelector(`script[src="${conf.gygWidgetUrl}/v2/widget.js"]`)
      if (typeof script === 'undefined' || script === null) {
        const recaptchaScript = document.createElement('script')
        recaptchaScript.async = true
        recaptchaScript.defer = true
        recaptchaScript.setAttribute('src', `${conf.gygWidgetUrl}/v2/widget.js`)
        document.head.appendChild(recaptchaScript)
      }
    }
  }
</script>
